import { Pipe, PipeTransform } from '@angular/core';
import { Product, ProductCategory } from '../services/entities';

@Pipe({
  name: 'productCategories'
})
export class ProductCategoriesPipe implements PipeTransform {
  transform(products: Product[]): ProductCategory[] {
    return Array.from(new Set(products.map(product => product.productCategoryId).sort()));
  }
}
